// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_UnlinkRecebimentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for DELETE /payments/anticipations/unlink_recebimento
 *
 * Returns whether unlink succeeded.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_UnlinkRecebimentoResponseDados {
unlinked: boolean
}

export type SubaccountsAnticipations_UnlinkRecebimentoResponse = ApiResponse<SubaccountsAnticipations_UnlinkRecebimentoResponseDados>;

registerResponseContract('SubaccountsAnticipations_UnlinkRecebimentoResponse', {
  unlinked: { type: 'boolean', required: true },
})
